document.addEventListener('DOMContentLoaded', function() {
  // Initialize accordion functionality
  const teamSections = document.querySelectorAll('.team-section');
  
  teamSections.forEach(section => {
    const header = section.querySelector('h3');
    
    header.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      const isCurrentlyActive = section.classList.contains('active');
      
      // Close all sections
      teamSections.forEach(s => {
        s.classList.remove('active');
        s.querySelector('.accordion-icon').textContent = '+';
      });
      
      // If the clicked section wasn't active, open it
      if (!isCurrentlyActive) {
        section.classList.add('active');
        section.querySelector('.accordion-icon').textContent = '−';
      }
    });
  });

  // Modal functionality
  const modal = document.getElementById('sustainabilityModal');
  const modalOverlay = modal;
  const closeButton = modal.querySelector('.modal-close');
  const philosophyBtn = document.getElementById('philosophyBtn');

  function openModal() {
    modalOverlay.classList.add('active');
    document.body.style.overflow = 'hidden'; // Prevent scrolling
  }

  function closeModal() {
    modalOverlay.classList.remove('active');
    document.body.style.overflow = ''; // Restore scrolling
  }

  // Event listeners for modal
  if (philosophyBtn) {
    philosophyBtn.addEventListener('click', function(e) {
      e.preventDefault();
      openModal();
    });
  }

  if (closeButton) {
    closeButton.addEventListener('click', closeModal);
  }

  // Close modal when clicking outside
  modalOverlay.addEventListener('click', function(e) {
    if (e.target === modalOverlay) {
      closeModal();
    }
  });

  // Close modal on escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modalOverlay.classList.contains('active')) {
      closeModal();
    }
  });
}); 